import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable, of } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class OpcionRespuestaEncuestaService implements RequestCRUD<any, ResponseServiceModel> {
	private API_URL;
	private handleError: HandleError;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private enviromentGlobalService: EnviromentGlobalService) {
		this.handleError = httpErrorHandler.createHandleError('OpcionRespuestaEncuesta');
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	get(entry: any): Observable<ResponseServiceModel> {
		// tslint:disable-next-line:max-line-length
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/OpcionRespuestaEncuestaAdministrador/Paginado?PageNumber=${entry.numeroPagina}&PageSize=12`, entry).pipe(
			retry(2)
		);
	}
	update(entry: any): Observable<ResponseServiceModel> {
		return this.http.put<ResponseServiceModel>(`${this.API_URL}/OpcionRespuestaEncuestaAdministrador/${entry.opcion_respuesta_id}`, entry).pipe(
			retry(2)
		);
	}
	create(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/OpcionRespuestaEncuestaAdministrador/Crear`, entry).pipe(
			retry(2)
		);
	}

	delete(entry: any): Observable<ResponseServiceModel> {
		return this.http.delete<ResponseServiceModel>(`${this.API_URL}/OpcionRespuestaEncuestaAdministrador/${entry.opcion_respuesta_id}`).pipe(
			retry(2)
		);
	}
	getPreguntas(): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/PreguntaEncuesta`).pipe(
			retry(2)
		);
	}

  getPreguntasBySeccion(seccionId: number): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/PreguntaEncuesta/seleccion/seccion/${seccionId}`)
      .pipe(retry(2));
  }

  getModuloEncuestaByAnio(anio: number): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/ModuloEncuesta/anio/${anio}`).pipe(
			retry(2)
		);
	}

  getSeccionEncuestaByModulo(moduloId: number): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/SeccionEncuesta/modulo/${moduloId}`)
      .pipe(retry(2));
  }

}
